import {
  FlatTypeListDetails,
  LocationListDetails,
  TenureListDetails,
} from "@/interfaces/filterlistInterface";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL;

interface InitialState {
  location: LocationListDetails[];
  district: string;
  minPrice: number;
  maxPrice: number;
  flatType: string;
  TOP: string;
  Tenure: string;
  error: string | null;
  loading: boolean;
}

const initialState: InitialState = {
  location: [],
  district: "",
  minPrice: 0,
  flatType: "",
  TOP: "",
  Tenure: "",
  maxPrice: 0,
  error: null,
  loading: false,
};

export const getLocationsList = createAsyncThunk(
  "filterlist/getLocationsList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/property/location-list`);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch Location List"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
    }
  }
);

// export const getMinPriceList = createAsyncThunk(
//   "filterlist/getMinPriceList",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/property-meta-data/price-list`
//       );
//       return response.data;
//     } catch (error: unknown) {
//       if (error instanceof AxiosError) {
//         return rejectWithValue(
//           error.response?.data?.message || "Failed to fetch minimum Price List"
//         );
//       } else {
//         // Handle other types of errors, if necessary
//         return rejectWithValue("An unknown error occurred");
//       }
//     }
//   }
// );

// export const getMaxPriceList = createAsyncThunk(
//   "filterlist/getMaxPriceList",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/property-meta-data/price-list`
//       );
//       return response.data;
//     } catch (error: unknown) {
//       if (error instanceof AxiosError) {
//         return rejectWithValue(
//           error.response?.data?.message || "Failed to fetch Maximum Price List"
//         );
//       } else {
//         // Handle other types of errors, if necessary
//         return rejectWithValue("An unknown error occurred");
//       }
//     }
//   }
// );

// export const getFlatTypeList = createAsyncThunk(
//   "filterlist/getFlatTypeList",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/flat-types`);
//       return response.data;
//     } catch (error: unknown) {
//       if (error instanceof AxiosError) {
//         return rejectWithValue(
//           error.response?.data?.message || "Failed to fetch flat type List"
//         );
//       } else {
//         // Handle other types of errors, if necessary
//         return rejectWithValue("An unknown error occurred");
//       }
//     }
//   }
// );

// export const getTOPList = createAsyncThunk(
//   "filterlist/getTOPList",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/property/construction-status`
//       );
//       return response.data;
//     } catch (error: unknown) {
//       if (error instanceof AxiosError) {
//         return rejectWithValue(
//           error.response?.data?.message || "Failed to fetch Location List"
//         );
//       } else {
//         // Handle other types of errors, if necessary
//         return rejectWithValue("An unknown error occurred");
//       }
//     }
//   }
// );

// export const getTenureList = createAsyncThunk(
//   "filterlist/getTenureList",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/property/tenure-list`);
//       return response.data;
//     } catch (error: unknown) {
//       if (error instanceof AxiosError) {
//         return rejectWithValue(
//           error.response?.data?.message || "Failed to fetch tenure List"
//         );
//       } else {
//         // Handle other types of errors, if necessary
//         return rejectWithValue("An unknown error occurred");
//       }
//     }
//   }
// );

const filterlistSlice = createSlice({
  name: "filterlist",
  initialState,
  reducers: {
    resetFilterlist: (state) => {
      state.location = [];
      state.minPrice = 0;
      state.flatType = "";
      state.TOP = "";
      state.Tenure = "";
      state.maxPrice = 0;
      state.error = null;
      state.loading = false;
    },
    setFilterlist: (state, action) => {
      state.location = action.payload?.location;
      state.minPrice = action.payload?.minPrice;
      state.flatType = action.payload?.flatType;
      state.TOP = action.payload?.TOP;
      state.Tenure = action.payload?.Tenure;
      state.district = action.payload?.district;
      state.maxPrice = action.payload?.maxPrice;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocationsList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getLocationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.location = action.payload;
      })
      .addCase(getLocationsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    // .addCase(getMinPriceList.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getMinPriceList.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.minPrice = action.payload;
    // })
    // .addCase(getMinPriceList.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload as string;
    // })
    // .addCase(getMaxPriceList.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getMaxPriceList.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.maxPrice = action.payload;
    // })
    // .addCase(getMaxPriceList.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload as string;
    // })
    // .addCase(getFlatTypeList.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getFlatTypeList.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.flatType = action.payload;
    // })
    // .addCase(getFlatTypeList.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload as string;
    // })
    // .addCase(getTOPList.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getTOPList.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.TOP = action.payload;
    // })
    // .addCase(getTOPList.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload as string;
    // })
    // .addCase(getTenureList.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getTenureList.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.tenure = action.payload;
    // })
    // .addCase(getTenureList.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload as string;
    // });
  },
});

export const { resetFilterlist, setFilterlist } = filterlistSlice.actions;
export default filterlistSlice.reducer;
